module.exports = __webpack_public_path__ + "static/media/banner.b78029b1.jpg";